import { AudioDetailDto } from '@/service/interface';
import { AudioDto, GenerateStatus } from '@/service/type';
import { create } from 'zustand';

interface StoreState {
  audioList: AudioDto[];
  setAudioList: (audioListUpdater: AudioDto[] | ((prevAudioList: AudioDto[]) => AudioDto[])) => void;
  selectedInfo: AudioDto | null | AudioDetailDto;
  setSelectedInfo: (audioList: AudioDto | null | AudioDetailDto, passCheck?: boolean) => void;
  count: number;
  setCount: (count: number) => void;
  setAudioItem: (id: string, updatedData: Partial<AudioDto | { status?: GenerateStatus }>) => void;
  updateAudioInList: (val: { [x: string]: AudioDto | undefined }) => void;
}

export const useAudioListStore = create<StoreState>((set, get) => {
  return {
    audioList: [],
    setAudioList: (audioListUpdater: AudioDto[] | ((prevAudioList: AudioDto[]) => AudioDto[])) => {
      set(() => ({
        audioList: typeof audioListUpdater === 'function' ? audioListUpdater(get().audioList) : audioListUpdater,
      }));
    },
    selectedInfo: null,
    setSelectedInfo: (selectedInfo: AudioDto | AudioDetailDto | null, passCheck?: boolean) => {
      if (passCheck) {
        set({ selectedInfo });
        return;
      }
      if (
        selectedInfo?.is_generated ||
        selectedInfo?.status === 'validated' ||
        selectedInfo?.status === 'generated' ||
        selectedInfo === null
      ) {
        set({ selectedInfo });
      }
    },
    count: 0,
    setCount: (count: number) => set({ count }),
    setAudioItem: (id: string, updatedData: Partial<AudioDto>) => {
      set((state) => ({
        audioList: state.audioList.map((item) => (item.id === id ? { ...item, ...updatedData } : item)),
      }));
    },
    updateAudioInList: (val: { [x: string]: AudioDto | undefined }) => {
      const { setSelectedInfo } = get();
      const needChangeIdList = Object.keys(val);
      set((state) => ({
        audioList: state.audioList
          .map((item) => {
            // replace with update val
            if (needChangeIdList.includes(item.id)) {
              if (val[item.id] === undefined) {
                setSelectedInfo(null);
              }
              return val[item.id];
            }
            return item;
          })
          .filter((i) => !!i), //val[item.id] maybe undefined to act delete
      }));
    },
  };
});

interface IsPlayAudioInviewState {
  isPlayAudioInview: boolean | undefined;
  setIsPlayAudioInview: (isPlayAudioInview: boolean | undefined) => void;
}

export const useIsPlayAudioInview = create<IsPlayAudioInviewState>((set, get) => {
  return {
    isPlayAudioInview: undefined,
    setIsPlayAudioInview: (isPlayAudioInview: boolean | undefined) => set({ isPlayAudioInview }),
  };
});
